<div class="deviation">
  <div class="severity" [ngbTooltip]="severity===DeviationSeverity.warning ? ('ui.warning'|translate) : ('ui.blocking'|translate)"
    [ngClass]="{'bg-warning':severity===DeviationSeverity.warning, 'bg-danger':severity===DeviationSeverity.blocking}">
      &nbsp;
    </div>
  <div class="count">{{count}}</div>
  <jbm-label-with-ID
    [label]="description"
    [ID]="subjectId"
    [IDPosition]="IDPosition">
  </jbm-label-with-ID>
</div>
